import { Transaction } from "@solana/web3.js";
/**
 * Encodes a Transaction to a string (default: hex) without requiring all signatures.
 */
export function txEncode(tx, encoding = "hex") {
    return tx.serialize({ requireAllSignatures: false, verifySignatures: false }).toString(encoding);
}
/**
 * Decodes a string (default: hex) into a Transaction instance.
 */
export function txDecode(str, encoding = "hex") {
    return Transaction.from(Buffer.from(str, encoding));
}
/**
 * Build a Transaction with a strict instruction ordering:
 * 1) Nonce advance (if provided)
 * 2) Compute budget instructions (if any)
 * 3) Program instructions
 * 4) Memo instruction (if provided)
 */
export function assembleLegacyTransaction(options) {
    const { feePayer, recentBlockhash, nonceAdvanceIx, computeBudgetIxs, programIxs, memoIx } = options;
    const tx = new Transaction();
    tx.feePayer = feePayer;
    tx.recentBlockhash = recentBlockhash;
    if (nonceAdvanceIx) {
        tx.add(nonceAdvanceIx);
    }
    if (computeBudgetIxs && computeBudgetIxs.length > 0) {
        for (const ix of computeBudgetIxs)
            tx.add(ix);
    }
    for (const item of programIxs) {
        if (item instanceof Transaction) {
            for (const ix of item.instructions)
                tx.add(ix);
        }
        else {
            tx.add(item);
        }
    }
    if (memoIx) {
        tx.add(memoIx);
    }
    return tx;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbWFpbi9zaGFyZWQvdHgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFrQixXQUFXLEVBQStCLE1BQU0saUJBQWlCLENBQUM7QUFFM0Y7O0dBRUc7QUFDSCxNQUFNLFVBQVUsUUFBUSxDQUFDLEVBQWUsRUFBRSxXQUEyQixLQUFLO0lBQ3hFLE9BQU8sRUFBRSxDQUFDLFNBQVMsQ0FBQyxFQUFFLG9CQUFvQixFQUFFLEtBQUssRUFBRSxnQkFBZ0IsRUFBRSxLQUFLLEVBQUUsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUNuRyxDQUFDO0FBRUQ7O0dBRUc7QUFDSCxNQUFNLFVBQVUsUUFBUSxDQUFDLEdBQVcsRUFBRSxXQUEyQixLQUFLO0lBQ3BFLE9BQU8sV0FBVyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLEdBQUcsRUFBRSxRQUFRLENBQUMsQ0FBQyxDQUFDO0FBQ3RELENBQUM7QUFFRDs7Ozs7O0dBTUc7QUFDSCxNQUFNLFVBQVUseUJBQXlCLENBQUMsT0FPekM7SUFDQyxNQUFNLEVBQUUsUUFBUSxFQUFFLGVBQWUsRUFBRSxjQUFjLEVBQUUsZ0JBQWdCLEVBQUUsVUFBVSxFQUFFLE1BQU0sRUFBRSxHQUN2RixPQUFPLENBQUM7SUFFVixNQUFNLEVBQUUsR0FBRyxJQUFJLFdBQVcsRUFBRSxDQUFDO0lBQzdCLEVBQUUsQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDO0lBQ3ZCLEVBQUUsQ0FBQyxlQUFlLEdBQUcsZUFBZSxDQUFDO0lBRXJDLElBQUksY0FBYyxFQUFFLENBQUM7UUFDbkIsRUFBRSxDQUFDLEdBQUcsQ0FBQyxjQUFjLENBQUMsQ0FBQztJQUN6QixDQUFDO0lBRUQsSUFBSSxnQkFBZ0IsSUFBSSxnQkFBZ0IsQ0FBQyxNQUFNLEdBQUcsQ0FBQyxFQUFFLENBQUM7UUFDcEQsS0FBSyxNQUFNLEVBQUUsSUFBSSxnQkFBZ0I7WUFBRSxFQUFFLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQ2hELENBQUM7SUFFRCxLQUFLLE1BQU0sSUFBSSxJQUFJLFVBQVUsRUFBRSxDQUFDO1FBQzlCLElBQUksSUFBSSxZQUFZLFdBQVcsRUFBRSxDQUFDO1lBQ2hDLEtBQUssTUFBTSxFQUFFLElBQUksSUFBSSxDQUFDLFlBQVk7Z0JBQUUsRUFBRSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsQ0FBQztRQUNqRCxDQUFDO2FBQU0sQ0FBQztZQUNOLEVBQUUsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDZixDQUFDO0lBQ0gsQ0FBQztJQUVELElBQUksTUFBTSxFQUFFLENBQUM7UUFDWCxFQUFFLENBQUMsR0FBRyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ2pCLENBQUM7SUFFRCxPQUFPLEVBQUUsQ0FBQztBQUNaLENBQUMifQ==